import { Product } from "../../types/types";
export function getDefaultCategory(product: Product): string {
  return (
    product.browsePageHierarchy[product.browsePageHierarchy.length - 1]?.name ||
    ""
  );
}
